import PageHeader from '../../shared/PageHeader'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomTabs from '../../shared/CustomTabs'
import UserCollectionSummaryReport from './UserCollectionSummaryReport'
import UserCollectionDetailedReport from './UserCollectionDetailedReport'
import UserCollectionDailyReport from './UserCollectionDailyReport'
import UserCollectionDepositReport from './UserCollectionDepositReport'
import UserCollectionGroupedReport from './UserCollectionGroupedReport'
import { useSelector } from 'react-redux'
import { isBusiness42Receptionist } from '../../utils/businessLevelAccess'

export const userCollectionReportTabs = t => [
  {
    name: t('Summary'),
    content: <UserCollectionGroupedReport />,
  },
  // {
  //   name: t('Summary'),
  //   content: <UserCollectionSummaryReport />,
  // },
  {
    name: t('Detailed'),
    content: <UserCollectionDetailedReport />,
  },
  {
    name: t('Daily Cash'),
    content: <UserCollectionDailyReport />,
  },
  // {
  //   name: t('Deposit Summary'),
  //   content: <UserCollectionDepositReport reportType="summary" />,
  // },
  // {
  //   name: t('Deposit Detailed'),
  //   content: <UserCollectionDepositReport reportType="detailed" />,
  // },
]

function UserCollectionReport() {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const prevActiveTab = state?.activeInvoiceTabIndex || 0
  const user = useSelector(state => state?.auth?.user)

  if (isBusiness42Receptionist(user)) {
    return (
      <div className="main-page-container flex items-center justify-center">
        <div className="text-center text-gray-600">
          <h2 className="text-lg font-semibold">{t('Access denied')}</h2>
          <p className="mt-2">{t('Receptionists cannot access the User Collection Report.')}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <div className="flex items-center justify-between">
        <PageHeader
          title={t('User Collection Report')}
          iconSize={20}
          Icon={i18n.language === 'en' ? FaArrowCircleLeft : FaArrowCircleRight}
          onIconClick={() => navigate(-1)}
        />
      </div>

      <div className="mt-2 w-full h-full">
        <CustomTabs
          tabs={userCollectionReportTabs(t)}
          activeTabIndex={prevActiveTab}
        />
      </div>
    </div>
  )
}

export default UserCollectionReport
